export default "__VITE_ASSET__BLyij7xS__";